import { ApiService } from "@/services/api/ApiService";

export type SystemEmailTemplate =
  | "welcome_business"
  | "welcome_consumer"
  | "access_approved"
  | "access_request";

export const SYSTEM_EMAIL_TEMPLATE_LABELS: Record<SystemEmailTemplate, string> = {
  welcome_business: "Welcome — Business User",
  welcome_consumer: "Welcome — Consumer",
  access_approved: "Access Approved",
  access_request: "Access Request",
};

export class SystemEmailService {
  static async preview(template: SystemEmailTemplate): Promise<string> {
    const result = await ApiService.invoke<{ html: string }>({
      resource: "system-emails",
      action: "preview",
      data: { template },
    });
    return result?.html ?? "";
  }

  static async sendTest(template: SystemEmailTemplate, recipient: string): Promise<void> {
    await ApiService.invoke({
      resource: "system-emails",
      action: "sendTest",
      data: { template, recipient },
    });
  }
}
